// Class: motion.easing.IEasing

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var IEasing = function() {}

// Meta

IEasing.__name__ = ["motion","easing","IEasing"];
IEasing.__isInterface__ = true;
IEasing.prototype = {
	
};
IEasing.prototype.__class__ = IEasing.prototype.constructor = $hxClasses["motion.easing.IEasing"] = IEasing;

// Init



// Statics




// Export

exports.default = IEasing;